import { storeCreator } from '@/utils/store/store.utils';

interface State {
  modalLayers: number[];
  nextModalId: number;
  pushModalLayer: () => number;
  popModalLayer: () => void;
  resetStore: () => void;
  isTopModal: (id: number) => boolean;
}

const useAutoBlockedModalStore = storeCreator<State>((set, get) => ({
  modalLayers: [],
  nextModalId: 1,

  pushModalLayer: () => {
    const id = get().nextModalId;
    set((state) => ({
      modalLayers: [...state.modalLayers, id],
      nextModalId: state.nextModalId + 1,
    }));
    return id;
  },

  popModalLayer: () => {
    set((state) => ({
      modalLayers: state.modalLayers.slice(0, -1),
      nextModalId: state.modalLayers.length <= 1 ? 1 : state.nextModalId, 
    }));
  },

  resetStore: () => {
    set({ modalLayers: [], nextModalId: 1 });
  },

  isTopModal: (id) => {
    const { modalLayers } = get();
    return modalLayers.length > 0 && modalLayers[modalLayers.length - 1] === id;
  },
}));

export default useAutoBlockedModalStore;
